export default __webpack_public_path__ + "static/media/truck.fc605c25.jpeg";